import { render, staticRenderFns } from "./GeneralTab.vue?vue&type=template&id=772fd586&scoped=true&"
import script from "./GeneralTab.vue?vue&type=script&lang=js&"
export * from "./GeneralTab.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTab.vue?vue&type=style&index=0&id=772fd586&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772fd586",
  null
  
)

export default component.exports